// extracted by mini-css-extract-plugin
export var avatarContainer = "_ej-0";
export var avatarTypingWave = "_ej-i";
export var gray = "_ej-f";
export var green = "_ej-c";
export var icon = "_ej-9";
export var image = "_ej-1";
export var lg = "_ej-6";
export var md = "_ej-5";
export var presenceDot = "_ej-b";
export var red = "_ej-d";
export var sm = "_ej-4";
export var status = "_ej-a";
export var typingDot = "_ej-h";
export var typingPill = "_ej-g";
export var xl = "_ej-7";
export var xs = "_ej-3";
export var xxl = "_ej-8";
export var xxs = "_ej-2";
export var yellow = "_ej-e";